import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap, take } from 'rxjs/operators';

import * as fromRoot from '../../app/store/reducers/index';
import { isAuthenticated } from '../../auth/store';
import { MenuService } from '../../fw/fw-menus/services/menu.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    public rootStore: Store<fromRoot.IState>,
    public menuService: MenuService
  ) {}

  unauthenticated: boolean;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.rootStore.pipe(
      select(isAuthenticated),
      take(1),
      switchMap((authenticated: boolean) => {
        if (
          authenticated &&
          !this.unauthenticated &&
          !localStorage.getItem('homuser') &&
          !req.url.endsWith('/Account/LogOff')
        ) {
          this.unauthenticated = true;
          if (!this.menuService.sessionLost) {
            this.menuService.sessionLost = true;
            alert('Authentication lost. You will be redirected to signin.');
            this.menuService.logout(true);
          }
        } else {
          this.unauthenticated = false;
        }
        return next.handle(req).pipe(
          catchError((error: unknown) => {
            if (error instanceof HttpErrorResponse && error.status === 401 && !req.url.endsWith('/Account/LogOff')) {
              if (!this.menuService.sessionLost) {
                this.menuService.sessionLost = true;
                alert('Authentication lost. You will be redirected to signin.');
                this.menuService.logout(true);
              }
            }
            return throwError(() => error);
          })
        );
      })
    );
  }
}
